export default {
    init() {
      // JavaScript to be fired on all pages
        jQuery(document).ready(function () {
            jQuery('.content-search .go-button').on('click', function (e) {
                e.preventDefault();
                window.location.href = jQuery('.menu_select').val();
            });
        })

        jQuery('.navbar .slick-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          arrows: false,
          dots: false,
          fade: true,
          cssEase: 'linear',
        });

        jQuery('.content-text-slider .slick-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
        });

        jQuery('.content-news-block .slick-slider__news').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            centerPadding: '140px',
            prevArrow: jQuery('.prevv'),
            nextArrow: jQuery('.nextt'),
          });

        jQuery('.content-team-members .slick-slider').slick({
            prevArrow: jQuery('.prev'),
            nextArrow: jQuery('.next'),
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: false,
                },
            },
            ],
          });
    },
    finalize() {
      // JavaScript to be fired on all pages, after page specific JS is fired
    },
};

$(document).ready(function() {
    if ($( window ).width() < 1100) {
        $('.menu-item-has-children').prepend('<span class="dropdown-button"><span></span></span></span>');

        $('.dropdown-button').click(function(e) {
            e.preventDefault();
            $(this).parent().toggleClass('submenu-open');
        });
    }
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js